/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import { Button } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';
import Dialog from 'modules/common/dialog.component';
import Spinner from 'modules/common/spinner.component';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { createIntakeFromTemp, getIntakeSummaries } from 'modules/intake/intake.actions';
import { CREATE_INTAKE_FROM_TEMP_FAILURE, GET_INTAKE_SUMMARIES_FAILURE } from 'modules/intake/types';
import { getSubmittedTempFiles } from './store/actions/authorizations.actions';
import { GET_PENDING_AUTHS_FAILURE } from './store/types/authorizationTypes';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';

function SelectRcDialog(props) {

  const {
    onSubmit,
    onCancel,
    maxLength,
    disabled,
    authorization,
    ...rest
  } = props;

  const [isModalLoading, setIsModalLoading] = useState(false);
  const [internalUserId, setInternalUserId] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

    const handleSubmit = async () => {
      const record = props.authorization;
  
      setIsModalLoading(true);

      const createIntakeResp = await props.createIntakeFromTemp(record.tempFileId, internalUserId);
  
      if (createIntakeResp.type === CREATE_INTAKE_FROM_TEMP_FAILURE) {
        props.showToast('Failed to create intake record, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR});
      } else {
        const getPendingAuthsResp = await props.getSubmittedTempFiles();
        const getIntakeRecordsResp = await props.getIntakeSummaries();
        if (getPendingAuthsResp.type === GET_PENDING_AUTHS_FAILURE) {
            props.showToast('Failed to retrieve pending auths, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        } else if (getIntakeRecordsResp.type === GET_INTAKE_SUMMARIES_FAILURE) {
            props.showToast('Failed to retrieve intake records, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        } else {
            const authName = record.name || `${record.firstName || ''} ${record.lastName || ''}`.trim() || 'authorization';
            props.showToast(`Intake Record was created successfully for ${authName}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            onCancel(true);
        }
      }
  
      setIsModalLoading(false);
      
    };
  
  const sortedUsers = props.internalUsers 
    ? props.internalUsers
        .filter(user => user.firstName && user.firstName.length !== 0)
        .sort((a, b) => String(`${a.firstName} ${a.lastName}`).localeCompare(`${b.firstName} ${b.lastName}`))
    : [];

  return (
    <Dialog
      {...rest}
      title="Set Relocation Counselor"
      content={
        <div>
          <Box>
            <Autocomplete
              options={sortedUsers}
              getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${option.internalUserId})`}
              value={selectedUser}
              onChange={(event, newValue) => {
                setSelectedUser(newValue);
                setInternalUserId(newValue ? newValue.internalUserId : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Relocation Counselor"
                  variant="standard"
                  required={true}
                  margin="dense"
                />
              )}
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
            />
            <Typography variant="caption" display="block" color="primary">
                Required
            </Typography>
          </Box>
        </div>
      }
      actions={
        <>
            {isModalLoading && (<Spinner />)}
            {!isModalLoading && (
                <>
                    <Button disabled={disabled} onClick={onCancel} variant="outlined" color="primary">Cancel</Button>
                    <Button disabled={internalUserId == null} onClick={handleSubmit} variant="contained" color="primary">Create Intake Record</Button>
                </>
            )}

        </>
      }
    />
  );
}

const mapStateToProps = state => {
  const {
    common: { internalUsers }
  } = state;
  return { internalUsers };
};

export default compose(
  connect(mapStateToProps, {
    showToast,
    createIntakeFromTemp,
    getSubmittedTempFiles,
    getIntakeSummaries
  }),
)(SelectRcDialog);